import { render, staticRenderFns } from "./CoverageMain.vue?vue&type=template&id=1d8c55dd&scoped=true&"
import script from "./CoverageMain.vue?vue&type=script&lang=ts&"
export * from "./CoverageMain.vue?vue&type=script&lang=ts&"
import style0 from "./CoverageMain.vue?vue&type=style&index=0&id=1d8c55dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8c55dd",
  null
  
)

export default component.exports